<template>
  <div
    class="cly-vue-form-col py-8 px-6"
    :class="{'cly-vue-form-col--border': border }"
  >
    <slot />
  </div>
</template>
<script>
import countlyVue from '../../compat/vue-core';

export default countlyVue.components.BaseComponent.extend({
  props: {
    border: {
      type: Boolean,
      default: true,
    },
  },
});
</script>
<style scoped>
    .cly-vue-form-col + .cly-vue-form-col--border{
        border-left: 1px solid #ECECEC;
    }
</style>
